const mutations = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_USER_ROLE(state, val) {
        state.userRole = val
        localStorage.setItem('userRole', val)
    },
    // UPDATE_STATUS_CHAT(state, value) {
    //     state.AppActiveUser.status = value;
    // },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },
    UPDATE_SITE_TITLE(state, title) {
        state.site_title = title;
    },
    UPDATE_OFFLINE_READY(state, status) {
        state.offline_ready = status;
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {
        // find item index in search list state
        const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index)
        // update the main list
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

        // if val is true add it to starred else remove
        if(payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList.data[index])
        }else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.index == payload.index)
            // remove item using index
            state.starredPages.splice(index, 1);
        }
    },

    // The Navbar
    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10);
        state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false
        let lastItemInStarredLimited = state.starredPages[10];
        const starredPagesLimited = state.starredPages.slice(0, 10);
        state.starredPages = starredPagesLimited.concat(list);

        state.starredPages.slice(0,10).map((i) => {
            if(list.indexOf(i) > -1) downToUp = true
        })
        if(!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited);
        }
    },
    UPDATE_ACTIVE_ENTITY(state, entity) {
        localStorage.setItem('active_entity', JSON.stringify(entity))
        state.active_entity = entity
    },
    SET_ENTITY_LOAD_REDIRECT(state, path) {
        state.entity_load_redirect = path
    },
    SET_CONNECTIVITY_STATUS(state, status) {
        state.is_online = status
    },
    SET_FCM_PROGRESS(state, status) {
        localStorage.setItem('fcm_progress', status)
    },
    SET_SERVICE_WORKER(state, registration) {
        state.active_service_worker = registration
    },
    SET_CACHE(state, payload) {
        state.api_cache[payload.key] = payload.value
    },
    UPDATE_RENDER_PERSON_ID(state, payload) {
        let session_id = payload.session_id
        let obj = state.person_id_rendering.ids.findIndex(val => val.session_id == session_id)
        if (obj < 0) {
            state.person_id_rendering.ids.push({
                session_id,
                status: payload.status,
                data: payload.data
            })
        } else {
            state.person_id_rendering.ids[obj].status = payload.status
            state.person_id_rendering.ids[obj].data = payload.data
        }
    }
}

export default mutations
